import { render, staticRenderFns } from "./Cert.vue?vue&type=template&id=a68e1e9c&scoped=true&"
import script from "./Cert.vue?vue&type=script&lang=js&"
export * from "./Cert.vue?vue&type=script&lang=js&"
import style0 from "./Cert.vue?vue&type=style&index=0&id=a68e1e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e1e9c",
  null
  
)

component.options.__file = "Cert.vue"
export default component.exports